export default __webpack_public_path__ + "static/media/uz.15a9a22c.svg";